
const digest = 'a37bf9e32c951334048efa3a5ad4efe6a971798ef820160ef66ff2a88d058fd5';
const classes = {"wrapper":"_wrapper_to991_1","content":"_content_to991_13","warnings":"_warnings_to991_20","row":"_row_to991_24","item":"_item_to991_29","name":"_name_to991_34","value":"_value_to991_37","title":"_title_to991_40","controls":"_controls_to991_50","ingredient":"_ingredient_to991_54"};
const css = `._wrapper_to991_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  border: 1px solid #eaedf3;
  border-top: 0;
  display: flex;
  padding: 24px;
  gap: 12px;
}
._wrapper_to991_1:first-child {
  border-top: 1px solid #eaedf3;
}
._wrapper_to991_1 ._content_to991_13 {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
  padding-right: 24px;
}
._wrapper_to991_1 ._warnings_to991_20 {
  display: flex;
  flex-direction: column;
}
._wrapper_to991_1 ._row_to991_24 {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
._wrapper_to991_1 ._row_to991_24 ._item_to991_29 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
._wrapper_to991_1 ._row_to991_24 ._item_to991_29 ._name_to991_34 {
  color: #9ea0a5;
}
._wrapper_to991_1 ._row_to991_24 ._item_to991_29 ._value_to991_37 {
  color: #3e3f42;
}
._wrapper_to991_1 ._row_to991_24 ._title_to991_40 {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  flex: 1;
}
._wrapper_to991_1 ._row_to991_24 ._title_to991_40 ._value_to991_37 {
  color: #000000;
  font-weight: 500;
}
._wrapper_to991_1 ._row_to991_24 ._title_to991_40 ._controls_to991_50 {
  display: flex;
  gap: 10px;
}
._wrapper_to991_1 ._row_to991_24 ._ingredient_to991_54 {
  display: flex;
  font-size: 14px;
}
._wrapper_to991_1 ._row_to991_24 ._ingredient_to991_54 span {
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  